<template>
  <div class="set">
    <van-nav-bar
      :title="$t('m.rlb_span5')"
      left-text=""
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>

    <!-- <form> -->
    <div class="rlbaddbox">
      <div class="rlbaddtitle">{{ $t("m.rlb_span9") }}</div>
      <div class="rlbinpbox">
        <div class="rlbrmb">￥</div>
        <input
          readonly="readonly"
          type="text"
          style="font-size: 28px"
          :placeholder="$t('m.rlb_span11')"
          @click="show = true"
          v-model="account"
        />
      </div>
      <!-- <div class="rlbaddtitle" style="padding-top:15px;">可转入金额{{money}}元</div> -->
    </div>
    <div class="rlbbtnbox">
      <button
        class="rlbbtn"
        style="background-color: var(--bg-color)"
        @click="ribaoIn"
      >
        {{ $t("m.rlb_span13") }}
      </button>
    </div>
    <van-number-keyboard
      :show="show"
      theme="custom"
      extra-key="."
      :close-button-text="$t('m.finish')"
      @blur="show = false"
      @input="onInput"
      @delete="onDelete"
    />
    <!-- </form> -->
  </div>
</template>

<script>
import request from "@utils/request";
import "@/assets/css/rilibao/rlbadd.css";
export default {
  //   name: "",
  data() {
    return {
      show: false,
      account: "",
      money: ""
    };
  },
  created() {
    // this.Account();
  },
  methods: {
    onInput(value) {
      let vm = this;
      this.account = vm.account + value;
    },
    onDelete() {
      console.log("sdsdsa");
      this.account = this.account.slice(0, this.account.length - 1);
    },
    onClickLeft() {
      this.$router.back(-1);
    },
    // async Account() {
    // 	let res = await AccountPost();
    // 	if (res) {
    // 		this.money = res.data.money;
    // 	}
    // },
    async ribaoIn() {
      if (this.account == "") {
        this.$dialog.message("金额不能为空");
        return;
      }
      if (this.account <= 0) {
        this.$dialog.message("金额的值必须不小于1");
        return;
      }
      request
        .post("/user/ribao/in", { money: this.account }, { login: true })
        .then(res => {
          console.log(res);
          this.$router.push({
            path: "/rilibaoindex"
          });
          this.$dialog.success("转入成功");
          console.log("转出");
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
        });
    }
  },
  components: {}
};
</script>
<style scoped lang="less">
.rlbbtn:active {
  opacity: 0.3 !important;
}
/deep/ .van-nav-bar .van-icon {
  color: #333;
}
</style>
